import CustomerWxProps from '@/customer/models/CustomerWxProps';
import CustomerOuterProps from '@/customer/models/CustomerOuterProps';
import CustomerPublicProps from '@/customer/models/CustomerPublicProps';
import CustomerTraceInfo from '@/customer/models/CustomerTraceInfo';
import MemberInfo from '@/customer/models/MemberInfo';

interface CustomerInterface {
  weixinId: string;
  openid: string;
  wxProps: CustomerWxProps;
  outerProps: CustomerOuterProps;
  publicProps: CustomerPublicProps;
  privateProps: object;
  sex: number;
  city?: string;
  country?: string;
  province?: string;
  groups: number[];
  remarkName?: string;
  realName?: string;
  birth?: string;
  address?: string;
  phone?: string;
  qq?: string;
  email?: string;
  remarks: string[];
  telephone?: string;
  edu?: string;
  maritalStatus?: number;
  career?: string;
  industry?: string;
  income?: number;
  hobby?: string;
  citizenId?: string;
  wechat?: string;
  source?: string;
  gmtCreate: string;
  gmtModified: string;
  status: number;
  topics: number[];
  importFrom: number;
  memberInfo?: MemberInfo;
  traceInfo?: CustomerTraceInfo;
  latelyInteractiveTime?: string;
}

export enum Sex {
  UnKnow = 0,
  Male = 1,
  Female = 2,
}

export default class Customer implements CustomerInterface {
  public weixinId: string;
  public openid: string;
  public wxProps: CustomerWxProps;
  public outerProps: CustomerOuterProps;
  public publicProps: CustomerPublicProps;
  public privateProps: object;
  public sex: number;
  public city?: string;
  public country?: string;
  public province?: string;
  public groups: number[];
  public remarkName?: string;
  public realName?: string;
  public birth?: string;
  public address?: string;
  public phone?: string;
  public qq?: string;
  public email?: string;
  public remarks: string[];
  public telephone?: string;
  public edu?: string;
  public maritalStatus?: number;
  public career?: string;
  public industry?: string;
  public income?: number;
  public hobby?: string;
  public citizenId?: string;
  public wechat?: string;
  public source?: string;
  public gmtCreate: string;
  public gmtModified: string;
  public status: number;
  public topics: number[];
  public importFrom: number;
  public memberInfo?: MemberInfo;
  public traceInfo?: CustomerTraceInfo;
  public latelyInteractiveTime?: string;

  constructor(c: Customer) {
    this.weixinId = c.weixinId;
    this.openid = c.openid;
    this.wxProps = c.wxProps;
    this.outerProps = c.outerProps;
    this.publicProps = c.publicProps;
    this.privateProps = c.privateProps;
    this.sex = c.sex;
    this.city = c.city;
    this.country = c.country;
    this.province = c.province;
    this.groups = c.groups;
    this.remarkName = c.remarkName;
    this.realName = c.realName;
    this.birth = c.birth;
    this.address = c.address;
    this.phone = c.phone;
    this.qq = c.qq;
    this.email = c.email;
    this.remarks = c.remarks;
    this.telephone = c.telephone;
    this.edu = c.edu;
    this.maritalStatus = c.maritalStatus;
    this.career = c.career;
    this.industry = c.industry;
    this.income = c.income;
    this.hobby = c.hobby;
    this.citizenId = c.citizenId;
    this.wechat = c.wechat;
    this.source = c.source;
    this.gmtCreate = c.gmtCreate;
    this.gmtModified = c.gmtModified;
    this.status = c.status;
    this.topics = c.topics;
    this.importFrom = c.importFrom;
    this.memberInfo = c.memberInfo;
    this.traceInfo = c.traceInfo;
    this.latelyInteractiveTime = c.latelyInteractiveTime;
  }
}
